export type CostCalculationResult = {
  appliedFactor: number | null;
  netPriceWithSurcharge: number | null;
};

// Leonardo procurement-category factors used to calculate the surcharge price.
const PROCUREMENT_CATEGORY_FACTORS: Record<string, number> = {
  MP: 1.54,
  FSA: 1.49,
  FLS: 1.39
};

/** Calculate the Leonardo cost values from the net price and procurement category. */
export function calculateCostCalculation(
  netPrice: unknown,
  procurementCategory: string
): CostCalculationResult {
  // "Other" has no factor and keeps the surcharge price manually editable.
  const appliedFactor =
    PROCUREMENT_CATEGORY_FACTORS[procurementCategory] ?? null;

  if (appliedFactor == null) {
    return {
      appliedFactor: null,
      netPriceWithSurcharge: null
    };
  }

  if (netPrice == null || netPrice === "") {
    // The factor is still displayed even when no net price has been provided.
    return {
      appliedFactor,
      netPriceWithSurcharge: null
    };
  }

  // Accept decimal values entered with either a dot or a comma separator.
  const parsedNetPrice = Number(String(netPrice).replace(",", "."));

  // WBW/net price with surcharge = net price multiplied by the factor.
  return {
    appliedFactor,
    netPriceWithSurcharge: Number.isFinite(parsedNetPrice)
      ? parsedNetPrice * appliedFactor
      : null
  };
}
